module.exports = __webpack_public_path__ + "img/piyao_6.29075d5a.png";